export function getParamsFromType(type?: string) {
  switch (type) {
    case "pending":
      return {
        submitted: false,
      };
    case "submitted":
      return {
        submitted: true,
      };
    default:
      return {
        all: true,
      };
  }
}
